import apiClient from "./baseService";
import {handleAxiosError} from "./axiosErrorHandler";

export const sendSupportMessage = async (body: FormData): Promise<void> => {
    await apiClient.post("/supports", body, {headers: {"Content-Type": "multipart/form-data"}}).catch(handleAxiosError);
};
